import React, { Component } from 'react'
import Nav from 'react-bootstrap/Nav'
import { extend } from '../../../utils/classes'

export class Link extends Component {
  render() {
    const { parentClass, ...other } = this.props
    return (
      <Nav.Link className={extend(parentClass, 'link')} {...other}></Nav.Link>
    )
  }
}

export default Link
